import AlliancesLandingScreen from './containers/alliancesLandingScreen'

export {default as AlliancesLandingScreenLayout} from './components/alliancesLandingScreenLayout'

export default AlliancesLandingScreen
